import { useState } from "react";
import MobileHeaderSection from "../../Components/MobileHeaderSection";
import MobileLeftSection from "../../Components/MobileLeftSection";
import MobileBottomMenu from "../../Components/MobileBottomMenu";
import AlertPopup from "../../Components/AlertPopup";
import { useParams } from "react-router-dom";
import { IoTimerSharp } from "react-icons/io5";
export default function MobileTest({
  OpenNext,
  setOpenNext,
  Loading,
  laodingS,
  error,
  Styles,
  CurrentQuestionNumber,
  AlertData,
  loading,
  QuestionData,
  QuestionTimer,
  CurrentQuestion,
  QuestionAnswerData,
  setQUestionAnserData,
  setCurrentQuestion,
  setCurrentQuestionNumber,
  AttemptedQuestion,
  handlePrev,
  setAlertData,
  handleSubmitForm,
  handleNext,
}) {
  const [SideOpener, setSideOpner] = useState(false);
  const OpenSideMenu = (e) => {
    setSideOpner(!SideOpener);
  };
  const { Id } = useParams();
  return (
    <>
      <AlertPopup
        OpenNext={OpenNext}
        setOpenNext={setOpenNext}
        AlertData={AlertData}
      />
      <div className="Mobile_View_css">
        <div
          onClick={OpenSideMenu}
          className={SideOpener ? "menu-overlay active" : "menu-overlay"}
          id="menuOverlay"
        ></div>
        <MobileLeftSection SideOpener={SideOpener} />
        <div className="main-content">
          <MobileHeaderSection Page="Live Test" OpenSideMenu={OpenSideMenu} />
          <section style={{ padding: "10px 10px 10px 10px" }}>
            {loading || laodingS ? <Loading /> : ""}

            <section className={Styles.Test_Live_Height}>
              {error ? (
                <p>{error}</p>
              ) : (
                <div className={Styles.Margin2}>
                  <div>
                    {window.innerWidth <= 480 ? (
                      <div>
                        {/* <div>
                          <h3 style={{ textAlign: "center", margin: "20px 0" }}>
                            T-LAT
                          </h3>
                        </div> */}
                        <table
                          className={Styles.QuestionSec2}
                          style={{
                            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                            borderRadius: "10px",
                            border: "none",
                          }}
                        >
                          <tbody>
                            <tr>
                              <td colspan={2}>
                                <div>
                                  <div
                                    style={{
                                      marginTop: "-20px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <h4 style={{ fontSize: "20px" }}>
                                      Q:{CurrentQuestionNumber + 1}
                                    </h4>
                                    <div>
                                      <h4
                                        className={Styles.TimerHead}
                                        style={{ color: "#2C3F8C" }}
                                      >
                                        <span>
                                          <IoTimerSharp />
                                        </span>
                                        <span>{QuestionTimer} min</span>
                                      </h4>
                                    </div>
                                  </div>
                                  <p className={Styles.Questiondet}>
                                    {CurrentQuestion?.Question}
                                  </p>
                                </div>
                                <div className={Styles.OptionContainer}>
                                  {CurrentQuestion?.Options?.map((ev, j) => (
                                    <div
                                      className={Styles.Options}
                                      key={j + 367}
                                    >
                                      <input
                                        type="radio"
                                        name="Options"
                                        checked={
                                          QuestionAnswerData[
                                            CurrentQuestionNumber
                                          ]?.Answer == ev
                                            ? true
                                            : false
                                        }
                                        onChange={(e) => {
                                          let answerData = [...QuestionData];
                                          answerData[
                                            CurrentQuestionNumber
                                          ].Answer = ev;

                                          setQUestionAnserData([...answerData]);
                                        }}
                                      />
                                      <p>{ev}</p>
                                    </div>
                                  ))}
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td colspan={2}>
                                <div className={Styles.NumberQuestionData}>
                                  <span>
                                    Number of Questions : <b> 30</b>
                                  </span>
                                  <span>
                                    Time : <b>15 min</b>
                                  </span>
                                </div>
                              </td>
                            </tr>

                            <tr>
                              <td colspan={2}>
                                <div>
                                  <div className={Styles.NumberQuestionData}>
                                    <span>
                                      Number of Attempted :{" "}
                                      <b
                                        style={{ color: "rgb(132, 225, 132)" }}
                                      >
                                        {" "}
                                        {AttemptedQuestion}
                                      </b>
                                    </span>
                                    <span>
                                      Number of Pending :{" "}
                                      <b style={{ color: "blue" }}>
                                        {QuestionAnswerData?.length
                                          ? QuestionAnswerData?.length -
                                            AttemptedQuestion
                                          : 0}
                                      </b>
                                    </span>
                                  </div>
                                </div>
                              </td>
                            </tr>

                            <tr>
                              <td colspan={2}>
                                <div className={Styles.QuestionBtns}>
                                  <button
                                    disabled={CurrentQuestionNumber === 0}
                                    className={
                                      CurrentQuestionNumber === 0
                                        ? Styles.disabled
                                        : Styles.active
                                    }
                                    onClick={() => handlePrev()}
                                  >
                                    PREV
                                  </button>
                                  {QuestionData?.length &&
                                  QuestionData?.length - 1 ==
                                    CurrentQuestionNumber &&
                                  CurrentQuestionNumber !== 0 ? (
                                    <button
                                      style={{ background: "#2C3F8C" }}
                                      onClick={() => {
                                        setAlertData({
                                          msg: "Are You sure want to Submit your test ?",
                                          Alert: () => handleSubmitForm(),
                                        });
                                        setOpenNext(true);
                                      }}
                                    >
                                      SUBMIT
                                    </button>
                                  ) : (
                                    <button
                                      style={{ background: "#2C3F8C" }}
                                      onClick={() => handleNext()}
                                    >
                                      NEXT
                                    </button>
                                  )}
                                </div>
                              </td>
                            </tr>

                            <tr>
                              <td colspan={2}>
                                <div className={Styles.Attempted_Questions2}>
                                  {QuestionData?.map((ev, i) => (
                                    <div
                                      onClick={() => {
                                        setCurrentQuestion(QuestionData[i]);
                                        setCurrentQuestionNumber(i);
                                      }}
                                      className={
                                        i === CurrentQuestionNumber
                                          ? Styles.QuestionNumber_Progress
                                          : QuestionAnswerData[i]?.Answer
                                          ? Styles.QuestionNumber_Attempted
                                          : Styles.QuestionNumber
                                      }
                                    >
                                      {i + 1}
                                    </div>
                                  ))}{" "}
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <table className={Styles.QuestionSec2}>
                        <tbody>
                          <tr>
                            <td rowspan={2}>
                              <div>
                                <h4 style={{ fontSize: "20px" }}>
                                  Q:{CurrentQuestionNumber + 1}
                                </h4>
                                <p className={Styles.Questiondet}>
                                  {CurrentQuestion?.Question}
                                </p>
                              </div>
                              <div className={Styles.OptionContainer}>
                                {CurrentQuestion?.Options?.map((ev, j) => (
                                  <div className={Styles.Options} key={j + 367}>
                                    <input
                                      type="radio"
                                      name="Options"
                                      checked={
                                        QuestionAnswerData[
                                          CurrentQuestionNumber
                                        ]?.Answer == ev
                                          ? true
                                          : false
                                      }
                                      onChange={(e) => {
                                        let answerData = [...QuestionData];
                                        answerData[
                                          CurrentQuestionNumber
                                        ].Answer = ev;

                                        setQUestionAnserData([...answerData]);
                                      }}
                                    />
                                    <p>{ev}</p>
                                  </div>
                                ))}
                              </div>
                            </td>
                            <td>
                              <div>
                                <h4 className={Styles.TimerHead}>
                                  <span>
                                    <IoTimerSharp />
                                  </span>{" "}
                                  <span>{QuestionTimer} min</span>
                                </h4>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td>
                              {" "}
                              <div className={Styles.Attempted_Questions2}>
                                {QuestionData?.map((ev, i) => (
                                  <div
                                    onClick={() => {
                                      setCurrentQuestion(QuestionData[i]);
                                      setCurrentQuestionNumber(i);
                                    }}
                                    className={
                                      i === CurrentQuestionNumber
                                        ? Styles.QuestionNumber_Progress
                                        : QuestionAnswerData[i]?.Answer
                                        ? Styles.QuestionNumber_Attempted
                                        : Styles.QuestionNumber
                                    }
                                  >
                                    {i + 1}
                                  </div>
                                ))}{" "}
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td>
                              <div>
                                <div className={Styles.NumberQuestionData}>
                                  <span>
                                    Number of Attempted :{" "}
                                    <b style={{ color: "rgb(132, 225, 132)" }}>
                                      {AttemptedQuestion}
                                    </b>
                                  </span>
                                  <span>
                                    Number of Pending :{" "}
                                    <b style={{ color: "blue" }}>
                                      {QuestionAnswerData?.length
                                        ? QuestionAnswerData?.length -
                                          AttemptedQuestion
                                        : 0}
                                    </b>
                                  </span>
                                  <div className={Styles.QuestionBtns}>
                                    <button
                                      disabled={CurrentQuestionNumber === 0}
                                      className={
                                        CurrentQuestionNumber === 0
                                          ? Styles.disabled
                                          : Styles.active
                                      }
                                      onClick={() => handlePrev()}
                                    >
                                      PREV
                                    </button>
                                    {QuestionData?.length &&
                                    QuestionData?.length - 1 ==
                                      CurrentQuestionNumber &&
                                    CurrentQuestionNumber !== 0 ? (
                                      <button
                                        onClick={() => {
                                          setAlertData({
                                            msg: "Are You sure want to Submit your test ?",
                                            Alert: () => handleSubmitForm(),
                                          });
                                          setOpenNext(true);
                                        }}
                                      >
                                        SUBMIT
                                      </button>
                                    ) : (
                                      <button onClick={() => handleNext()}>
                                        NEXT
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td>
                              <div className={Styles.NumberQuestionData}>
                                <span>
                                  Number of Questions : <b> 30</b>
                                </span>
                                <span>
                                  Time : <b>15 min</b>
                                </span>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    )}

                    {/* <div className={Styles.TopQuestionTime}>
      
        <div>
          <h4 className={Styles.Heading}>
            <span>
              <IoTimerOutline />
            </span>{" "}
            <span>{QuestionTimer} min</span>
          </h4>
        </div>
      </div>
      <table className={Styles.QuestionSecTable}>
        <tbody className={Styles.QuestionSecTable}>
          {CurrentQuestion ? (
            <tr className={Styles.QuestionSec}>
              <td>
                <div>
                  <h4 style={{ fontSize: "20px" }}>
                    Q:{CurrentQuestionNumber + 1}
                  </h4>
                  <p>
                    In publishing and graphic design, Lorem ipsum is a
                    placeholder text commonly used to demonstrate the
                    visual form of a document or a typeface without
                    relying on meaningful content. Lorem ipsum may be used
                    as a
                  </p>
                </div>
              </td>
              <td>
                <div>
                  <h4>Options :</h4>
                  <div className={Styles.Options}>
                    <input type="radio" />
                    <p>test option 1</p>
                  </div>
                  <div className={Styles.Options}>
                    <input type="radio" />
                    <p>test option 1</p>
                  </div>
                  <div className={Styles.Options}>
                    <input type="radio" />
                    <p>test option 1</p>
                  </div>
                  <div className={Styles.Options}>
                    <input type="radio" />
                    <p>test option 1</p>
                  </div>
                </div>
                <div className={Styles.QuestionBtns}>
                  <button
                    disabled={CurrentQuestionNumber === 0}
                    className={
                      CurrentQuestionNumber === 0
                        ? Styles.disabled
                        : Styles.active
                    }
                    onClick={() => handlePrev()}
                  >
                    PREV
                  </button>
                  {QuestionData?.length &&
                  QuestionData?.length - 1 == CurrentQuestionNumber &&
                  CurrentQuestionNumber !== 0 ? (
                    <button onClick={() => handleSubmitForm()}>
                      SUBMIT
                    </button>
                  ) : (
                    <button onClick={() => handleNext()}>NEXT</button>
                  )}
                </div>
              </td>
            </tr>
          ) : (
            ""
          )}
        </tbody>
      </table>

      <div className={Styles.Attempted_Questions}>
        <div className={Styles.Help}>
          <div>
            {/* <span>
              <IoIosHelpCircleOutline />
            </span>
            <span>Help</span> 
          </div>

          <div>
            <span>
              Number Questions : <b> 30</b>
            </span>
            <span>
              Time : <b>15 min</b>
            </span>
          </div>
        </div>

        <div>
          {QuestionData?.map((ev, i) => (
            <div
              onClick={() => {
                setCurrentQuestion(QuestionData[i]);
                setCurrentQuestionNumber(i);
              }}
              className={
                i === CurrentQuestionNumber
                  ? Styles.QuestionNumber_Progress
                  : Styles.QuestionNumber
              }
            >
              {i + 1}
            </div>
          ))}
        </div>
      </div> */}
                  </div>
                </div>
              )}
            </section>
          </section>
          <MobileBottomMenu Page="LiveTest" />
        </div>
      </div>
    </>
  );
}
